import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-toggle',
  standalone: true,
  templateUrl: './toggle.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toggle.component.scss'
})
export class ToggleComponent {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() public checked: boolean = false;
  @Input() disabled: boolean = false;
  @Output() toggled: EventEmitter<{
    name: string;
    checked: boolean;
  }> = new EventEmitter<{
    name: string;
    checked: boolean;
  }>();

  onToggle(event: Event): void {
    const value: boolean = (event.target as HTMLInputElement).checked;
    this.checked = value;
    this.toggled.emit({
      name: this.name,
      checked: value
    });
  }
}
